import React from 'react';
import { motion } from 'framer-motion';

const Modal = ({ setSelectedImg, selectedImg }) => {
 // console.log(selectedImg)
  function handleClick(e)  {
    if (e.target.classList.contains('backdropp')) {
     // console.log(selectedImg)
      setSelectedImg(null);
    }
    //console.log("hello")
  }

  return (
    <motion.div  className="backdropp"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      onClick={handleClick}
    >
      <motion.img src={selectedImg} alt="enlarged pic" 
        initial={{ y: "-100vh" }}
        animate={{ y: 0 }}
      />
    </motion.div>
  )
}

export default Modal;